import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// SystemLiveImage.tsx
import { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import LiveImagePreviewDialog from './LiveImagePreviewDialogue';
const SystemLiveImage = ({ imageUrl }) => {
    const theme = useTheme();
    const [imageError, setImageError] = useState(false);
    const [showPreviewDialog, setShowPreviewDialog] = useState(false);
    const [liveImageUrl, setLiveImageUrl] = useState('');
    const [frozenPreviewUrl, setFrozenPreviewUrl] = useState('');
    const generateImageUrl = (sasUrl) => {
        if (!sasUrl)
            return '';
        const sep = sasUrl.includes('?') ? '&' : '?';
        return `${sasUrl}${sep}t=${Date.now()}`;
    };
    useEffect(() => {
        if (imageUrl?.trim()) {
            const updateImage = () => {
                setLiveImageUrl(generateImageUrl(imageUrl));
                setImageError(false);
            };
            updateImage();
            const interval = setInterval(updateImage, 5000);
            return () => clearInterval(interval);
        }
        else {
            setLiveImageUrl('');
        }
    }, [imageUrl]);
    const handleOpenImagePreviewDialog = () => {
        if (liveImageUrl) {
            setFrozenPreviewUrl(liveImageUrl);
            setShowPreviewDialog(true);
        }
    };
    const handleCloseImagePreviewDialog = () => {
        setShowPreviewDialog(false);
    };
    const hasValidImage = !!imageUrl && !imageError && !!liveImageUrl;
    return (_jsxs(_Fragment, { children: [hasValidImage ? (_jsx(Box, { sx: {
                    height: 352,
                    width: '100%',
                    overflow: 'hidden',
                    borderRadius: '6px',
                    cursor: 'pointer'
                }, onClick: handleOpenImagePreviewDialog, children: _jsx("img", { src: liveImageUrl, alt: 'Live stream', onLoad: () => setImageError(false), onError: () => setImageError(true), style: { height: '100%', width: '100%', objectFit: 'cover' } }) })) : (_jsx(Box, { sx: {
                    backgroundColor: theme.palette.action.disabled,
                    height: 352,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    overflow: 'hidden',
                    borderRadius: '6px'
                }, children: _jsx(Typography, { variant: 'subtitle1', color: 'white', children: "Connection not available" }) })), showPreviewDialog && (_jsx(LiveImagePreviewDialog, { open: showPreviewDialog, onClose: handleCloseImagePreviewDialog, imgSrc: frozenPreviewUrl, alt: 'Image preview' }))] }));
};
export default SystemLiveImage;
